import { Service } from '@roc/feature-app-core';

export abstract class BaseBorrowerLoanSubmissionService extends Service {}
